<template>
    <div>
        <ul class="pagination">
            <div>
                <li class="button" v-if="isShowPrevAndNext" @click="onPrevFunc()">
                    Previous
                </li>
            </div>
            <li v-for="page in pages" :key="page" :class="{ active: currentPage == page - 1 }"
                @click="onClickFunc(page)">
                {{ page === -1 ? "···" : page }}
            </li>
            <li class="button" v-if="isShowPrevAndNext" @click="onNextFunc()">
                Next
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'pagenation',
        props: [
            'isShowPrevAndNext',
            'currentPage',
            'dataLength',
            'displayNumOfEachPage',
            'displayPageTabNum'
        ],
        computed: {
            pages: function () {
                const displayPageTabNum = this.displayPageTabNum || 5;
                const length = this.dataLength;
                const pageNum =
                    length % this.displayNumOfEachPage > 0 ?
                    parseInt(length / this.displayNumOfEachPage) + 1 :
                    parseInt(length / this.displayNumOfEachPage);
                if (pageNum > displayPageTabNum) {
                    const median = displayPageTabNum - 2;
                    const offset = parseInt(median / 2);
                    const current = this.currentPage;
                    let prevEllipse = current + 1 > median;
                    let nextEllipse = current + 1 < pageNum - median + 1;
                    let array = [1];
                    if (prevEllipse) {
                        array.push(-1);
                    }
                    for (let i = 0; i < median; i += 1) {
                        if (prevEllipse && nextEllipse) {
                            array.push(current - offset + 1 + i);
                        } else if (prevEllipse) {
                            array.push(pageNum - median + i);
                        } else if (nextEllipse) {
                            array.push(i + offset + 1);
                        }
                    }
                    if (nextEllipse) {
                        array.push(-1);
                    }
                    array.push(pageNum);
                    return array;
                } else {
                    let array = [];
                    for (let i = 0; i < pageNum; i += 1) {
                        array.push(i + 1);
                    }
                    return array;

                }
            },
        },
        methods:{
            onPrevFunc(){
 this.$emit('prevClick');
            },
            onNextFunc(){
                console.log("sqqqqqq"+this.pages);
                 this.$emit('nextClick',this.pages);
            },
            onClickFunc(page){
                console.log("ssssss"+page);
                this.$emit('itemClick',page);
            }
        }
    }
</script>

<style lang="scss">
    @media screen and (max-width: 768px) {
        .pagination {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;

            .button {
                padding: 6px 12px;
                width: 100px;
            }

            li {
                text-align: center;
                font-family: "GenJyuuGothic-P-Regular";
                font-size: 20px;
                line-height: 32px;
                font-weight: normal;
                font-stretch: normal;
                color: #e8cbad;
                padding: 6px 0;
                height: 44px;
                width: 44px;
                margin: 20px 5px;
                border: 1px solid #e8cbad;
                border-radius: 22px;
                cursor: pointer;

                &.active,
                &:hover {
                    color: #fff;
                    background-color: #e8cbad;
                }
            }
        }
    }

    // pc
    @media screen and (min-width: 769px) {
        .pagination {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;

            .button {
                padding: 6px 12px;
                min-width: 100px;
            }

            li {
                text-align: center;
                font-family: "GenJyuuGothic-P-Regular";
                font-size: 20px;
                line-height: 32px;
                font-weight: normal;
                font-stretch: normal;
                color: #e8cbad;
                padding: 6px 0;
                height: 44px;
                width: 44px;
                margin: 20px 10px;
                border: 1px solid #e8cbad;
                border-radius: 22px;
                cursor: pointer;

                &.active,
                &:hover {
                    color: #fff;
                    background-color: #e8cbad;
                }
            }
        }
    }
</style>